import React from 'react';
import { Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { useStyles } from '../styles';
import { TOKENS } from '../../../styles/tokens';

interface IFinalBlockItemProps {
  title: string,
  link: string,
  isLocal?: boolean,
}
const FinalBlockItem = ({ title, link, isLocal }:IFinalBlockItemProps) => {
  const classes = useStyles();
  const linkStyle = { color: TOKENS.accentText, overflowWrap: 'anywhere' as const };

  return (
    <div className={classes.final_block_item}>
      <Typography
        variant="h6"
        color="#292929"
        fontWeight="bold"
      >
        {title}
      </Typography>
      <Typography
        variant="body1"
      >
        {/* The link text is a raw URL with no spaces to break on, so without this it
            overflows the card on narrow viewports instead of wrapping. */}
        {isLocal ? (
          <Link style={linkStyle} to={link}>
            {link}
          </Link>
        ) : (
          <a
            target="_blank"
            rel="noreferrer"
            style={linkStyle}
            href={link}
          >
            {link}
          </a>
        )}
      </Typography>
    </div>
  );
};

export default FinalBlockItem;
